import * as React from "react";
const SvgAlerts = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeLinecap: "square", strokeWidth: 1.5, d: "M12 9.75v4M12 16v.2m0-12.95-9.5 16h19z" }));
export default SvgAlerts;
